export const environment = {
  production: false,
  gtmId: 'GTM-KSNNC58H',
  appUrl: 'https://niretxoko-dev.example.com',
};
